import { inject } from '@angular/core'
import { Router, CanActivateFn } from '@angular/router'
import { jwtDecode } from 'jwt-decode'
import { environment } from '../../../environments/environment'

export const adminGuard: CanActivateFn = (): boolean => {
  const router = inject(Router)

  const authData = JSON.parse(localStorage.getItem('ANMS-AUTH') || '{}')
  const token = authData.accessToken

  if (!token) {
    router.navigate(['/login'])
    return false
  }

  try {
    const decoded: any = jwtDecode(token)
    const roleClaim = environment.auth0.roles

    // 👇 Extract roles from the custom claim
    const roles: string[] = decoded[roleClaim] || []

    const isAdmin = roles.includes('SUPERADMIN')

    if (!isAdmin) {
      router.navigate(['/login'])
      return false
    }

    return true
  } catch (error) {
    console.error('Invalid JWT:', error)
    router.navigate(['/login'])
    return false
  }
}
